/**
 * @generated SignedSource<<0250bad84cadaef4b881c8a09e774e50>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ParticipativeModuleResultsFormField_result",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ParticipativeModuleResultsFormFieldPie_result"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ParticipativeModuleResultsFormFieldBar_result"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ParticipativeModuleResultsFormFieldStacked_result"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ParticipativeModuleResultsFormFieldStackedAbsolute_result"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ParticipativeModuleResultsFormFieldMultiBar_result"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ParticipativeModuleResultsFormFieldMap_result"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ParticipativeModuleResultsFormFieldWordCloud_result"
    }
  ],
  "type": "ParticipativeModuleResultsFormField",
  "abstractKey": "__isParticipativeModuleResultsFormField"
};

node.hash = "6b3ea6c2841e804a06d38c2e005e5d8c";

module.exports = node;
